import { Button } from '@/components/common/Button';
import { FlexCol } from '@/components/common/Flex';
import { Paragraph, Text } from '@/components/common/Typography';
import { FlexProps } from '@chakra-ui/react';
import { Goal } from '@common/goals';
import { configByGoalType } from '../config';
import { showWireInstructionModal } from '../WireInstructionModal';

interface ConsolidateRetirementAccountsSectionProps extends FlexProps {
    goal: Goal;
    goalAccountId: string;
}

const ConsolidateRetirementAccountsSection = ({
    goal,
    goalAccountId,
    ...props
}: ConsolidateRetirementAccountsSectionProps) => {
    const goalConfig = configByGoalType[goal.type];
    return (
        <FlexCol
            minH={160}
            px={8}
            py={8}
            bg="gray.50"
            rounded="md"
            gap={10}
            {...props}
        >
            <Text fontWeight={600} fontSize="md" pr={4}>
                Consolidate retirement accounts
            </Text>
            <Paragraph fontSize="sm" lineHeight="taller" color="textMuted">
                Easily manage your retirement portfolio in one place, and save
                on fees*. Your retirement account has $500k SIPC insurance and
                custodied at BNY Mellon | Pershing, one of the largest
                custodians in the world.
            </Paragraph>
            <Button
                bg={goalConfig.color}
                _hover={{ bg: goalConfig.color, opacity: 0.8 }}
                onClick={() => showWireInstructionModal({ goalAccountId })}
                onClickEvent="Show Wire Instructions Button Clicked"
            >
                See wire instructions
            </Button>
        </FlexCol>
    );
};

export default ConsolidateRetirementAccountsSection;
